export default {
	SERIE: 'serie',
	BREAKDOWN1: 'breakdown1',
	BREAKDOWN2: 'breakdown2'
}
